import { render, staticRenderFns } from "./PaxConnectButton.vue?vue&type=template&id=4ea6dd7c"
import script from "./PaxConnectButton.vue?vue&type=script&lang=js"
export * from "./PaxConnectButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports